// API URL configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Utility function to check if a JWT token is valid (not expired)
export const isTokenValid = (token) => {
  if (!token) return false;
  
  try {
    // JWT tokens have three parts separated by dots
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    
    // Decode the payload (second part)
    const payload = JSON.parse(atob(parts[1]));
    
    // Check if token has expiration
    if (!payload.exp) return false;
    
    // Check if token is expired (exp is in seconds, Date.now() is in milliseconds)
    const expirationTime = payload.exp * 1000;
    const currentTime = Date.now();
    
    // Add a small buffer (5 seconds) to account for clock differences
    return currentTime < (expirationTime - 5000);
  } catch (error) {
    console.error('Error validating token:', error);
    return false;
  }
};

// Get valid token from localStorage or return null
export const getValidToken = () => {
  // Check recruiter token first, then admin token
  const recruiterToken = localStorage.getItem('recruiterToken');
  if (isTokenValid(recruiterToken)) {
    return recruiterToken;
  }

  const adminToken = localStorage.getItem('token');
  if (isTokenValid(adminToken)) {
    return adminToken;
  }

  // Remove invalid tokens
  if (recruiterToken) localStorage.removeItem('recruiterToken');
  if (adminToken) localStorage.removeItem('token');
  return null;
};

// Get any valid auth token (student, recruiter, alumni, partner, or admin)
export const getAnyValidToken = () => {
  // Check student token
  const studentToken = localStorage.getItem('studentAuthToken');
  if (isTokenValid(studentToken)) {
    return studentToken;
  }

  // Check recruiter token
  const recruiterToken = localStorage.getItem('recruiterToken');
  if (isTokenValid(recruiterToken)) {
    return recruiterToken;
  }

  // Check alumni/admin token
  const token = localStorage.getItem('token');
  if (isTokenValid(token)) {
    return token;
  }

  // Check partner token
  const partnerToken = localStorage.getItem('partnerToken');
  if (isTokenValid(partnerToken)) {
    return partnerToken;
  }

  return null;
};

